(ns web3.screens.profile
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [web3.i18n :as i]
            [web3.components.widgets :as widgets]
            [web3.modals.alerts :as alerts]
            [web3.queries.root :as q-root]
            [web3.queries.profile :as q-profile]
            [web3.components.snackbar :as snackbar]
            [web3.forms.fields :as fields]
            [web3.modals.forms :as forms]
            [web3.routing.core :as routing]
            [web3.persistence.graphql :as g]
            [web3.screens.pro.offer :as pro]
            [web3.log :as log]
            [web3.view :as v]
            [web3.env :as env]
            [web3.auth.api :as auth]))

(defn user-mutation
  [{:keys [key component me on-complete]}]
  (fn [_ value opts]
    (-> me
        (select-keys [:email
                      :password

                      :firstName
                      :lastName
                      :professionName
                      :companyName
                      :website
                      :mobilePhone
                      :officePhone
                      :personImage
                      :companyImage])
        (assoc key value)
        (q-profile/profile-update! (merge opts
                                          {:component component
                                           :on-complete on-complete})))))

(defn persisted-field
  [{:keys [component me on-persist read-only?]}
   [field-name key]]
  (fields/from-schema
    field-name
    {:name field-name
     :key field-name
     :read-only? read-only?
     :persisted-value (get me key)
     :persist-value! (user-mutation (merge {:key key
                                            :component component
                                            :me me}
                                           (when on-persist
                                             {:on-complete (partial on-persist key)})))}))
(v/defview email-change-confirm
           []
           [alerts/alert-view
            {:text-primary (i/get :account/email.changed)
             :text-secondary (i/get :account/email.changed.continue
                                    {:email (get-in (q-root/me) [:me :email])})
             :buttons [{:label (i/get :i/ok)
                        :on-click #(auth/logout!)}]}])
(defn redirect-url [args ]
  (let [data (:data  (js->clj (first args) :keywordize-keys true) )
        url (get-in data [:me_generate_ticket :website]) ]
    ;(js/window.location.href )
    (set! (.-location js/window) url)
    )
  )

(defn alert-message [title message]
  (alerts/add-frame
   [alerts/alert-view
    {:text-primary (i/to-do title)
     :text-secondary (i/to-do message)
     :buttons [{:label (i/to-do "Ok")
                :on-click #(alerts/drop-frames 1)}]}]))

(v/defview detail
           {:header {:title (i/get :i/account)
                     :content-right [widgets/edit-pencil-drawer [:edit :detail]]}}
           []
           (let [edit? (routing/get-query [:edit :detail])
                 this (r/current-component)
                 me (:me (q-root/me))
                 pro? (some-> me :proPlan (= "unlimited_free"))
                 logout! #(alerts/add-frame [email-change-confirm])]
             [:div.pad-all-3
              [widgets/graphql-state (assoc (g/mutation-state)
                                       :negative-pad? true
                                       :absolute? true)]
              (->> [[:User/firstName :firstName]
                    [:User/lastName :lastName]
                    [:User/email :email]]
                   (map (fn [[field-name key]]
                          [persisted-field
                           {:component this
                            :me me
                            :read-only? (or (= key :email)
                                            (not edit?))
                            :on-persist (fn [key]
                                          (when (= :email key)
                                            (logout!)))}
                           [field-name key]])))

     (if edit?
       (list
        [widgets/primary-button
         {:key :delete
          ;:on-click #(routing/nav! (routing/path-for :router/drawer [:account/change-password]))
          ;q-profile/generate-ticket! {:component this :token (str "dummy") }
          :on-click  (fn [obj ]
                       (g/clear-mutation-state! this)
                       (-> {:token (str "") }
                           (q-profile/generate-ticket!
                             {:component this
                              :on-complete
                                         (fn [& args]
                                           (log/println args)
                                           (let [data (:data  (js->clj (first args) :keywordize-keys true))
                                                 message (get-in data [:me_generate_ticket :website])
                                                 status (if (= "Success" message) "Change Password mail initiated. Please check your mail!" "Failure Occured!" )]
                                             (alert-message message status ))
                                           ) })) )
           :class "border-gray margin-bottom-3"}
         (i/get :account/change-password)]
        [widgets/black-button
         {:key :done
          :on-click #(routing/set-query! [:edit :detail] nil)}
         (i/get :i/done)])
       (when (:feature/pro? env/config)
        (if-not pro?
          [pro/upgrade-offer]
          [widgets/black-button
           {:class "margin-bottom-3 margin-top-4"
            :on-click #(routing/nav! (routing/path-for [:pro/start]))}
           (i/get :i/edit-pro-profile)])))]
    #_(when edit?
        (list
         [drawer/bottom-button
          {:key :delete
           :color :off-white}
          "Delete Account"]))))

(defn format-error
  [{:keys [graphql/error]
    :as mutation-state}]
  (cond-> mutation-state
          error (update :graphql/error
                        (fn [error]
                          (case (some-> error
                                        :error
                                        (.-graphQLErrors)
                                        (get 0)
                                        (.. -data -message))
                            "Wrong email or password."
                            {:message (i/get :account/change.password.wrong-password)}
                            "PasswordStrengthError: Password is too weak"
                            {:message (i/get :account/change.password.too-weak)}
                            error)))))

(v/defview change-password
           {:header {:title (i/get :i/change-password)}}
           []
           (let [{:keys [state] :as this} (r/current-component)
                 me (:me (q-root/me))
                 passwords-match?
                 (fn [matches-key value]
                   (when (not= value (forms/get-field [matches-key]))
                     {:invalid (i/get :forms/validators.confirm-password)}))
                 validators {:User/current-password [:required]
                             :User/new-password [:required
                                                 [:min-length 6]]
                             :User/confirm-password [(partial passwords-match? :User/new-password)]}
                 change-password!
                 (fn [{:keys [User/current-password
                              User/new-password]}]
                   (g/clear-mutation-state! this)
                   (-> {:currentPassword current-password
                        :newPassword new-password}
                       (q-profile/update-password!
                         {:component this
                          :on-complete
                                     (fn [& args]
                                       (snackbar/add-snack! (i/get :account/password.changed))
                                       (routing/nav! (routing/path-for :router/drawer [:account/profile])))})))]
             [:form.pad-all-3
              {:on-submit (partial forms/form-submit {:component this
                                                      :validators validators
                                                      :submit! change-password!})}
              [widgets/graphql-state (-> (g/mutation-state)
                                         (format-error)
                                         (assoc :negative-pad? true))]
              (doall
                (for [key [:User/current-password
                           :User/new-password
                           :User/confirm-password]]
                  ^{:key key}
                  [fields/from-schema key
                   (cond-> (forms/field-props state key)
                           (= key :User/confirm-password) (assoc :validators [(partial passwords-match? :User/new-password)]))]))
              [:button.margin-top-3
               {:type "submit"
                :style {:border "none"}
                :class (str widgets/black-button-classes
                            widgets/primary-button-classes
                            " flex width-100p")}
               (i/get :i/change)]]))
